import React, { useEffect, useRef } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import Datafeed from  '../../mydatafeed/datafeed';

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const supported_resolutions =  ['5', '1H', '1D', '1W']
export const TVChartContainerLine = () => {
	const chartContainerRef = useRef();

	const defaultProps = {
		symbol: 'USDCLP',
		interval: '5',
		datafeedUrl: 'https://demo_feed.tradingview.com',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		autosize: false,
		studiesOverrides: {
			"volume.volume.color.0": "rgba(92, 140, 134, 0.1)", // precio cierra arriba del precio de apertura
			"volume.volume.color.1": "rgba(70, 143, 134, 0.1)", // precio cierra abajo del precio de apertura
		},
	};
	useEffect(() => {
		const widgetOptions = {
			symbol: defaultProps.symbol,
			datafeed: Datafeed,
			interval: defaultProps.interval,
			container: chartContainerRef.current,
			library_path: defaultProps.libraryPath,
			theme: "dark",
			style: "3",
			timezone: "America/Santiago",
			locale: getLanguageFromURL() || 'en',
			disabled_features: ['use_localstorage_for_settings', 'header_saveload', 'left_toolbar'],
			charts_storage_url: defaultProps.chartsStorageUrl,
			charts_storage_api_version: defaultProps.chartsStorageApiVersion,
			defaultChartType: 'line',
			height: '90%',
			width: '100%',
			user_id: defaultProps.userId,
			fullscreen: defaultProps.fullscreen,
			autosize: defaultProps.autosize,
			studies_overrides: defaultProps.studiesOverrides,
			supported_resolutions: supported_resolutions,
		
		};

		const tvWidget2 = new widget(widgetOptions, );
		tvWidget2.onChartReady(() => {
			tvWidget2.applyOverrides({"mainSeriesProperties.style":3, "mainSeriesProperties.areaStyle.linecolor": "#40BFB1", 
			"mainSeriesProperties.areaStyle.color1": "rgba(64, 191, 177, 0.2)"})
			tvWidget2.setAutoScale(true)
		});
			
		
		return () => {
			tvWidget2.remove();
		};
	});
	return (
		<div
			ref={chartContainerRef}
			className={'TVChartContainerLine'}
			width = '100%'
			height='100%'
		/>
	);
}